import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './firestoreConnection';
import VueFire from 'vuefire';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import VueMoment from 'vue-moment';

Vue.use(VueFire);
Vue.use(Vuetify, {
  theme: {
    primary: '#FF6E40',
    secondary: '#DD2C00',
    accent: '#2962FF',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
});

Vue.use(VueMoment);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
